import type { JSX } from 'react';
import type { FichiersDeJeu } from '@taki/data-model';
import type { TakiSdk } from '@taki/sdk';
import type { CarteFichiers } from '@taki/ui';
import { FilesPanel } from './FilesPanel.js';

/**
 * LE CONTENU DE LA CARTE DES FICHIERS, pour la prop `fichiers` du ViewHost.
 *
 * Partage par l'ecran generique ET par un ecran d'app ecrit a la main : une app qui monte son propre ViewHost ne recode pas le panneau,
 * elle passe ce que cette fonction rend. `null` : la carte n'apparait pas (le jeu
 * n'ouvre pas les fichiers, ou ce qui est ouvert n'est pas une fiche : modele,
 * enfant de modele). Sur un BROUILLON, pas encore en base, un fragment vide
 * laisse la fiche rendre son apercu a la place.
 */
export function contenuDeCarteFichiers(options: {
  sdk: TakiSdk;
  jeu: { family: string; type?: string | undefined } | null;
  politique: FichiersDeJeu | null;
  /** L'id de la fiche ouverte, `null` quand ce n'est pas une fiche en base. */
  ficheOuverte: string | null;
  brouillon: boolean;
}): (carte: CarteFichiers) => JSX.Element | null {
  const { sdk, jeu, politique, ficheOuverte, brouillon } = options;
  return (carte) => {
    if (jeu === null || politique === null) return null;
    if (ficheOuverte === null) return brouillon ? <></> : null;
    return (
      <FilesPanel
        key={`${jeu.family}:${ficheOuverte}`}
        sdk={sdk}
        collection={jeu.family}
        type={jeu.type}
        recordId={ficheOuverte}
        titre={carte.titre}
        politique={politique}
        modifiable={carte.modifiable !== false}
      />
    );
  };
}
